// Mobile App Configuration
// Update these URLs with your actual app store links and deep link schemes

export const MOBILE_APP_CONFIG = {
    // Deep link schemes for opening the mobile app
    deepLinks: {
        ios: 'idearify://', // Replace with your actual iOS deep link scheme
        android: 'idearify://', // Replace with your actual Android deep link scheme
    },

    // App store URLs
    appStores: {
        ios: 'https://apps.apple.com/us/app/idearify/id6670697772', // Replace with actual App Store URL
        android: 'https://play.google.com/store/apps/details?id=com.idearify', // Replace with actual Play Store URL
    },

    // Universal link for iOS (if you have one)
    universalLink: 'https://idearify.com/app', // Replace with your actual universal link

    // App metadata
    app: {
        name: 'Idearify',
        description: 'Share and discover innovative ideas',
        icon: '/vite.png', // Replace with your app icon
    },

    // Banner settings
    banner: {
        showDelay: 3000, // Delay before showing banner (ms)
        autoShow: true, // Whether to show banner automatically
        dismissible: true, // Whether banner can be dismissed
    },

    // Redirect settings
    redirect: {
        autoRedirect: false, // Whether to automatically redirect on first visit
        redirectDelay: 1000, // Delay before redirect (ms)
        fallbackDelay: 2500, // Delay before showing app store fallback (ms)
    },

    // Feature flags
    features: {
        offlineAccess: true,
        pushNotifications: true,
        cameraIntegration: true,
        nativeSharing: true,
    },
};

// Helper function to get the appropriate app store URL based on platform
export const getAppStoreUrl = (isIOS: boolean): string => {
    return isIOS ? MOBILE_APP_CONFIG.appStores.ios : MOBILE_APP_CONFIG.appStores.android;
};

// Helper function to get the appropriate deep link based on platform
export const getDeepLinkUrl = (isIOS: boolean): string => {
    return isIOS ? MOBILE_APP_CONFIG.deepLinks.ios : MOBILE_APP_CONFIG.deepLinks.android;
};
